import React from 'react';
import Button from 'components/ButtonDeprecated';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Container from 'components/Container';
import Image from 'components/Image';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
import TooltipTrigger from 'components/TooltipTrigger';
import CoachingConstants from 'coaching/CoachingConstants';
import ZendeskWidget, { openWidget, useZendeskChatStatus } from 'coaching/components/ZendeskWidget';

import 'coaching/components/styles/CoachingCoachHelpContactSection.scss';

const imageUrls = [
  require('assets/images/coaching/aiden.png'),
  require('assets/images/coaching/dom.png'),
  require('assets/images/coaching/patti.png'),
];

export default function CoachingCoachHelpContactSection() {
  return (
    <Container>
      <ZendeskWidget />
      <div className="CoachingCoachHelpContactSection-cards">
        <Box noShadow className="CoachingCoachHelpContactSection-cardWrapper" textAlign="left">
          <BoxBody className="CoachingCoachHelpContactSection-card">
            <div>
              <Row>
                <Text size="xlarge" weight="semibold">
                  Have an urgent issue with your session?
                </Text>
              </Row>
              <Row>
                <Text color="graphite" size="medium">
                  {CoachingConstants.COACHING_COACH_CHAT_HOURS}
                </Text>
              </Row>
            </div>
            <Row size="small">
              {imageUrls.map(src => (
                <Image
                  circle
                  height={41}
                  width={41}
                  src={src}
                  className="CoachingCoachHelpContactSection-portrait"
                  key={src}
                />
              ))}
            </Row>
            <ChatStartButton buttonText="Start chatting now" />
          </BoxBody>
        </Box>
        <Box noShadow className="CoachingCoachHelpContactSection-cardWrapper" textAlign="left">
          <BoxBody className="CoachingCoachHelpContactSection-card">
            <div>
              <Row>
                <Text size="xlarge" weight="semibold">
                  Have any questions?
                </Text>
              </Row>
              <Row>
                <Text color="graphite" size="medium">
                  If you can't find the answer you need in our handbook, please reach out here! You
                  can also report scheduling, payment, or tech issues.
                </Text>
              </Row>
            </div>
            <Row size="small" className="CoachingCoachHelpContactSection-hours">
              <TextWithIcon icon="clock" color="graphite">
                {CoachingConstants.COACHING_COACH_HELP_HOURS}
              </TextWithIcon>
            </Row>
            <Button to={CoachingConstants.COACHING_COACH_HELP_FORM_ROUTE} color="koolaid">
              Send a request
            </Button>
          </BoxBody>
        </Box>
      </div>
    </Container>
  );
}

type ChatButtonProps = {
  buttonText: string;
};

function ChatStartButton(props: ChatButtonProps) {
  const [isChatOnline] = useZendeskChatStatus();

  return isChatOnline ? (
    <Button onClick={openWidget} color="koolaid" level="primary">
      {props.buttonText}
    </Button>
  ) : (
    <TooltipTrigger
      tooltip={CoachingConstants.COACHING_CHAT_HOURS}
      placement="bottom"
      alignment="middle">
      <div>
        <Button disabled color="paper" level="primary">
          {props.buttonText}
        </Button>
      </div>
    </TooltipTrigger>
  );
}
